import { render } from "./Beikostworkshop.vue?vue&type=template&id=7c92abb2&scoped=true"
import script from "./Beikostworkshop.vue?vue&type=script&lang=js"
export * from "./Beikostworkshop.vue?vue&type=script&lang=js"

import "./Beikostworkshop.vue?vue&type=style&index=0&id=7c92abb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c92abb2"]])

export default __exports__